import React, {Fragment, useContext, useEffect, useState} from "react";
import {GlobalContext} from "../context/GlobalState";
import {useLocation, useNavigate} from "react-router-dom";

interface ChangeWithZoneOptions {
  preserveRuleEditorOnZoneChange?: boolean;
}

export default function ChangeWithZone<T>(
  Component: React.ComponentType<T>,
  {preserveRuleEditorOnZoneChange = false}: ChangeWithZoneOptions = {},
) {
  const CE: React.FC<T> = (props) => {
    const { globalState } = useContext(GlobalContext)
    const [currentZone, setCurrentZone] = useState(globalState.currentZone)
  
    const location = useLocation();
    const navigate = useNavigate();
    const isThreatScoreRule = /^\/(settings\/)?(threat-scores|header-analysis)\/rules\//.test(location.pathname);
    
    useEffect(() => {
      if (currentZone === globalState.currentZone) return;
      setCurrentZone(globalState.currentZone);
      if (isThreatScoreRule) {
        navigate(globalState.globalZone ? '/settings/threat-scores' : '/threat-scores');
      } else if (!!currentZone && location.pathname.startsWith('/automation-rules/')) {
        navigate('/automation-rules');
      }
    }, [currentZone, globalState.currentZone, globalState.globalZone, isThreatScoreRule, location.pathname, navigate]);
    const componentKey = preserveRuleEditorOnZoneChange && isThreatScoreRule
      ? 'threat-score-rule'
      : currentZone;
    return (
      <Fragment key={componentKey}>
        {/*//@ts-ignore*/}
        {<Component
          currentZone={globalState.currentZone}
          globalZone={globalState.globalZone}
          {...props}
        />}
      </Fragment>
    )
  }
  return CE
}
